import { render, staticRenderFns } from "./NewPostItems.vue?vue&type=template&id=6a5f0b0d&scoped=true&"
import script from "./NewPostItems.vue?vue&type=script&lang=js&"
export * from "./NewPostItems.vue?vue&type=script&lang=js&"
import style0 from "./NewPostItems.vue?vue&type=style&index=0&id=6a5f0b0d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a5f0b0d",
  null
  
)

export default component.exports